const Colors = {
  surface: '#FCFCFC', //EN USO

  primary_50: '#FAFFDF',
  primary_300: '#91B833',
  primary_500: '#789D16',
  primary_600: '#4A6700', //EN USO
  primary_700: '#374E00',
  primary_900: '#131F00', //EN USO

  secondary_50: '#FCFCFC',
  secondary_100: '#FFDDB0',
  secondary_200: '#FFB94C', //EN USO
  secondary_300: '#E49D2A',
  secondary_400: '#C58307',
  secondary_500: '#A46B00', //EN USO
  secondary_600: '#9E8924', //EN USO
  secondary_700: '#643F00',
  secondary_900: '#2A1800',
  secondary_background: '#FBB03F', // uso viejo, no oficial?

  neutral_1: '#F6F7F5',
  neutral_2: '#F2F1E8', //EN USO
  neutral_3: '#FFEED9',
  neutral_4: '#D87748',

  neutral_10: '#FCFCFC',
  neutral_50: '#F2F1E8',
  neutral_100: '#E4E3DB',
  neutral_200: '#C7C7BF',
  neutral_300: '#ACACA4',
  neutral_400: '#91918A',
  neutral_500: '#777771',
  neutral_600: '#5F5F59',
  neutral_700: 'rgb(91, 91, 91)', //EN USO
  neutral_800: '#30312B',
  neutral_900: '#1B1C17',
  neutral_border: '#E9EDF5',

  black: '#000000',
  white: '#ffffff',

  black_high: 'rgba(0, 0, 0, 0.87)',
  black_medium: 'rgba(0, 0, 0, 0.6)',
  black_12: 'rgba(0, 0, 0, 0.12)', //EN USO
  black_05: 'rgba(0, 0, 0, 0.05)', //EN USO

  gray_base: '#5B5B5B',

  error: '#BA1B1B', //EN USO

  headline: '#4F4539',
};

/**
 * Paleta para gráficas. Separada de Colors porque responde a otras reglas: las
 * series categóricas se asignan siempre en este orden (nunca se reciclan ni se
 * reordenan al filtrar) y las rampas van de claro a oscuro sobre un solo tono.
 * Los valores están validados para daltonismo (protanopía/deuteranopía) y para
 * contraste contra el fondo blanco de las tarjetas.
 */
const ChartColors = {
  // SIC, Acopio, Evaluaciones, Altas, Bajas, y un sexto para roles de usuario
  categorical: ['#2A78D6', '#EB6834', '#1BAF7A', '#EDA100', '#E87BA4', '#7B61C9'],

  // Rampa secuencial en el olivo de Sirio: de menos a más actividad
  sequential: ['#A5BC6B', '#8EA554', '#788D3D', '#637724', '#4E6103'],
  // Tinta legible sobre cada escalón de la rampa (>= 4.5:1)
  sequentialInk: ['#1B1C17', '#1B1C17', '#1B1C17', '#FFFFFF', '#FFFFFF'],
  // Celda sin actividad
  sequentialEmpty: '#F2F1E8',

  // Estados de uso. Siempre acompañados de su etiqueta, nunca solo el color.
  estado: {
    alto: '#0CA30C',
    bajo: '#FAB219',
    nulo: '#D03B3B',
  },
  estadoSuave: {
    alto: 'rgba(12, 163, 12, 0.12)',
    bajo: 'rgba(250, 178, 25, 0.18)',
    nulo: 'rgba(208, 59, 59, 0.12)',
  },

  grid: '#E4E3DB',
  axis: '#91918A',
};

export { Colors, ChartColors };
